import { motion } from 'framer-motion';


const heroStyle = {
   strokeWidth: "3",
}


const svgVariants = {

hidden: {},
visible: {}
}

const pathVariants = {
hidden: {
opacity: 0,
pathLength: 0
},
visible: {
opacity: 1,
filter: "blur(1px)",
pathLength: 1,
transition: {
duration: 1.5,
ease: "easeInOut"
}
}
}

        
const People = () => {


return (

<div className='themePeople'>
  

<motion.svg width="" height="" viewBox="0 0 1144.43 605.23" fill="none" xmlns="http://www.w3.org/2000/svg"
variants={svgVariants}
initial='hidden'
animate='visible'>


<g id="lap-top">
<motion.path variants={pathVariants} style = {heroStyle} d="M1169.4,710.43H763.89V696.68h288.57l73.19-201c3.92-10.78,6.73-23.3-9.21-23.49-15-.18-123.3-.26-271.83,0,0,0-13.81-2.56-24.71,23.49s-75.2,213.83-75.2,213.83L630.94,639.68l0-12.06L899.4,628,885,617.12" transform="translate(-24.97 -107.25)"/>
</g>

<g id="woman">
<motion.path variants={pathVariants} style = {heroStyle} d="M475,556.1s-16.12-35.68-21.87-44.57-17.45-15.76-2.3-26.78,37.59-42.93,38.77-72.89c1.6-40.77-20.74-67.62-37.52-101.55,13,0,16.65,16.4,23.76,24.65,9.74,11.29,26.16,28,26.62,44,.78,27.36-6,124.44-11.19,144.16s-32.17,97.39-34.45,101.39,87.57,0,87.57,0c-2.56.11-12.63-77-13.6-84.72-3.46-27.51-4.28-55-6.4-82.6-3.34-43.37-13-96.68,18.7-132.47a82.59,82.59,0,0,1,36-23.68A93.75,93.75,0,0,1,601,296.75c12.27-1,15.78,10.66,22,18.82,36.62,48.11,83.24-2.38,100.58-39.5-1,2.06,6.46,3.27,7.52,3.38,8.48.93,13.69-5.72,19.06-11.23,7.9-8.11,19.6-28,1.2-32.37-8.8-2.06-18,5.07-26.66,2.59-6.29-1.79-10.23-8.18-11.83-14.53s-1.45-13-2.84-19.41c-4.86-22.24-29.1-37.13-51.75-34.89s-42.26,19-51.73,39.73-9.86,44.63-5.28,66.93c16-27.4,1.47-62.35,6.12-93.75,5.26-35.44,38.58-64.55,74.41-65s69.86,27.82,76,63.13c4.49,25.86-4.48,51.89-.58,77.76,3.24,21.47,19.25,38.26,19.41,60.56.14,19.56-7.75,49.76-9.85,67.82s-1.88,46.42,4.5,58,9.29,12.57,9.29,12.57c-33.75-13.29-60.81-35.09-67.8-72.36-8.08-43.08,18.9-77.9,41.84-111.44,0,0,0,40.88,26.3,47.33,13.62,3.35,27.55,4.74,41.35,7,21.36,3.55,36.49,17.41,40,39.34,3.82,23.6-4.32,46-4.86,69.49-.46,20.6.84,41.53,2.49,62.07a209.13,209.13,0,0,1-.71,36.45c-1.13,12.09-2.85,24.13-4.2,36.19.14-1.19-35-5.2-37.13-5.4-31.51-3-62.78,0-94.27,1.46l-100.28,4.5c-10.47.47-21.6.79-30.63-4.53-9.83-5.78-15.12-17.32-16.28-28.66s1.19-22.72,3.41-33.9,4.33-22.65,2.69-33.93c-3.48-23.92-25.71-43.69-49.88-44.36-4.16-.11-8.55.35-12,2.67s-5.64,7-4,10.82c2,4.9,8.43,5.95,13.74,5.94,14.68,0,30.41-2.45,43.21,4.74,13.91,7.81,19.94,24.7,22,40.52a135.12,135.12,0,0,1-4.67,56.07c-5,16.61-16.2,31.87-17.82,49.43-.84,9.16,7.69,17.24,15.16,20.86,15.14,7.34,33.92,2.48,49.64-.26,18.32-3.18,36.64-7.48,55.23-8.71,22.14-1.47,57.75-4,73.85,3.31,31.27,14.25,70.28,19.94,104.06,12.75,45.13-9.6-1.25-32.28-19.83-39.52-10.41-4-24.38-7.59-29.24-10.68s-17-27.46-19.07-40.93-5.67-57.35-3.62-65.88c5.41-22.5,25.05-29,45.68-32.42,6.6-1.09,18.75-3.24,23.2,3.77,7.32,11.51-6.41,21.39-16.24,22.14-19.92,1.51-45,7.5-49.3,12.21-6.31,7-14.29,20-15.1,29.44-.54,6.42,2.53,13.55,2.45,20.23-.24,19.43-11.81,36.89-19.85,54.09,0,0,30.47,6.36,62.62,14.08S880,615.81,887,621.12" transform="translate(-24.97 -107.25)"/>
</g>


<g id="pen">
<motion.path variants={pathVariants} style = {heroStyle} id="pen" data-name="pen" points="309.7 403.49 381.48 431.43 396.43 424.01 319.46 390.55 309.7 403.49"/>
</g>

<g id="man-arm-bottom">
<motion.path variants={pathVariants} style = {heroStyle} data-name="man-arm-bottom" d="M308.24,545.49l39.2-8.33s11.79,20.38,7.9,26.8S334,576.14,334,576.14l-19.26,1.08c1.32-.08,7.11-8.66,8.54-9.86,15-12.53,32.26-20.52,44.91-36.1,9-11.11,14.11-14.46,15.39-26.68,1.56-14.87,9.7-29.88,15.56-43.5s12.44-27.34,20.79-39.49c3-4.36,17.49-22.51,21.71-10.92.93,2.57.45,5.43-.27,8.07-8.42,30.73-31.57,57.67-50.09,82.93-3.61,4.92-16.56,31.92-21.89,41.4s-14.49,35.6-61.15,35.28-102.34-9.52-121.48,8-23.65,35.06-6.36,42.25c15.58,6.48,34.35,5.62,50.94,6.49q30.18,1.57,60.41,1.09,31.78-.53,63.49-3.33c19.83-1.76,41.58-2.47,60.65-8.32,9.74-3,39.21-15.52,32.76-29.95-2.24-5-11.55-5.74-17.23-4.88-3,.46-9.31,1.51-9.43,3.58-.14,2.24,7,5.34,13.69,5.46,11.92.2,19.5-9.14,20.45-10.34,2-2.5,5.58-7.1,4.22-12-.68-2.48-3.25-3.21-2.92-4.55.55-2.21,7-.58,9.75-3.58,3.19-3.47.74-12.51-3.9-18.2-8.54-10.49-25.79-11.16-36.74-5.86-.66.32-6.28,3-5.85,4.55.55,2,12.6-3.18,28.34-2,15.9,1.21,23.51,8,27.56,4,3.26-3.17,1.65-10.77-.95-15.37-6-10.58-41.95-11.38-41.95-11.38-10.73,4.55-31.33,21.85-40.64,26.72S365.75,569,365,568.91s18.09-28.77,29.39-35.44,15.16-15.37,31.16-12.17,36.78,11.08,52.23,26.42,17.73,18.12,17.73,18.12l-24.55-6.55" transform="translate(-24.97 -107.25)"/>
</g>

<g id="head">
<motion.path variants={pathVariants} style = {heroStyle} d="M284.4,401.78c23.74,68.72,89-17.59,103.72-40.62l6.5,42.66c-2.08-2.45-30.74-27.47-53.75,11.5l22.43-55.56c-22.69,15.46-80.94,29.73-96.79-11.49-19.88-33.8,32.4-87.76,41.95-108.39,15.66-33.84-37.64,4.57-3.47,35,6.53,5.32,7.5-1.15,8.61-3.08-14.25,51.28,97.61,110,104.71,56,.35-46,49-16.11,24.11-57.34-6.13-15.29-.71-22.67,7.52-34.9C477.42,126.73,245,69.75,273.86,245.4,215.2,11.87,534.86,141.21,435.49,180c-12.37,4.82-50.51-16.26-60.16,3.68-3.63,7.5,8.79,37.33-9.61,39.14-22-5.07-37.48,11.07-30.88,34.35l-14.53-6.4c-6.86-2.26,5.61-39.18-12.71-35.36-10,3.73-16.28,14.52-19.36,24.3-2.16,7.62.82,17.17-3.93,23.88-5.36,7.56-11.5,2-15.25-4.38-35.39-47.91-51.1,138.65-55.85,161.65,4.51-52.53,13.69-55,64.26-47.1" transform="translate(-24.97 -107.25)"/>
</g>

<g id="man-arm">
<motion.path variants={pathVariants} style = {heroStyle} d="M25,622.1h98c-6.8,0-18.5-11.39-22.16-16.71a22.1,22.1,0,0,1-3.72-17.84c3.36-14.81,19-25.54,31.09-32.79a168.21,168.21,0,0,1,51.09-20.14c8.26-1.73,27.62-6.16,33.44,3.12,3.2,5.09-.3,11.38-3,15.84-6.59,10.84-66.82,75.14-74.6,48.94-1.24-45.77,83.91-43,72.22-91.73-15.19-48.36,15.19-137.63-49.23-159.29-28.67,3.32.06,50.93,7,66.73,11,25,29.25,47.95,23.43,77.13-4.32,21.7-21.23,38.28-37.09,52.45-11.35,10.13-33.63,38.44-45.58,14.89s-12.68-54.24-14.15-79.88c-1.46-25.38-1.52-50.86-.55-76.27,1.1-28.71.58-61.49,11.6-88.31,10.21-24.86,32.38-43.34,56.88-54.39,29-13.08,60-14.88,90.58-21.67,26-6.1,15.34,101.22,26,123C290.75,459.74,380.6,605.58,209.51,573c-11-15.48,86.92-34.25,99.32-24.33" transform="translate(-24.97 -107.25)"/>
</g>


</motion.svg>   



    
</div>
)


}


export default People;